import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaCaixaCirurgica.vue?vue&type=template&id=618149a2&scoped=true"
import script from "./ModalSolicitacaoCirurgiaCaixaCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaCaixaCirurgica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618149a2",
  null
  
)

export default component.exports